module.exports = __webpack_public_path__ + "img/logo2.25a1d6c3.png";